export const iconFontAwesomePunctuationSymbolsGreaterThan = (
	<i className="fa-solid fa-greater-than"></i>
);
